<template>
    <div
        class="CustomRange"
        :class="CustomRangeClasses">
        <label
            class="CustomRange__Label"
            :class="LabelClasses"
            :style="{ left: `${offset}%` }">
            {{ label }}
        </label>
        <input
            ref="rangeBar"
            class="CustomRange__Input"
            type="range"
            min="0"
            max="100"
            :value="modelValue"
            :step="step"
            @mouseenter="isHovered = true"
            @mouseleave="isHovered = false"
            @input="updateSlider">
    </div>
</template>

<script>
export default {
    name: 'CustomRange',
    emits: ['update:modelValue'],
    data() {
        return {
            isHovered: false,
        };
    },
    computed: {
        label() {
            return `${this.offset}%`;
        },
        CustomRangeClasses() {
            return [{ 'CustomRange--Disabled': this.isDisabled }];
        },
        LabelClasses() {
            return [{ 'CustomRange__Label--Hovered': this.isHovered }];
        },
        offset() {
            return Math.ceil(this.modelValue);
        },
    },
    methods: {
        updateSlider(event) {
            const newVal = event.target.value;

            this.$emit('update:modelValue', newVal);
            this.changeBgBar();
        },
        changeBgBar(val) {
            const { rangeBar } = this.$refs;

            if (rangeBar) {
                rangeBar.style.background = `linear-gradient(to right, #0066ff ${val}%, #F0F0F0 ${val}%)`;
            }
        },
    },
    watch: {
        modelValue(val) {
            this.changeBgBar(val);
        },
    },
    props: {
        modelValue: {
            type: Number,
            default: 50,
        },
        step: {
            type: Number,
            default: 5,
        },
        isDisabled: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.changeBgBar(this.modelValue);
    },
};
</script>

<style lang="scss" scoped>
$thumbHeight: 14px;
$thumbWidth: 14px;
$thumbBorderRadius: 50%;
$thumbColor: $primary;

.CustomRange {
    position: relative;
    display: flex;
    transition: opacity $trs;

    &--Disabled {
        opacity: 0.6;
    }
}

.CustomRange__Label {
    position: absolute;
    bottom: calc(100% + 10px);
    width: 56px;
    padding: 10px 12px;
    color: $white;
    text-align: center;
    background-color: $black;
    border-radius: 10px;
    transform: translateX(-50%);
    opacity: 0;
    transition: opacity $trs;

    @include typo-additional-book;

    &--Hovered {
        opacity: 0.9;
    }
}

.CustomRange__Input {
    /* creating a custom design */
    width: 56px;
    height: 4px;
    background: #f0f0f0;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    appearance: none;
}

/* Thumb: webkit + Firefox */
.CustomRange__Input::-webkit-slider-thumb {
    width: $thumbWidth;

    /* creating a custom design */
    height: $thumbHeight;
    background-color: $thumbColor;
    border: none;
    border-radius: $thumbBorderRadius;
    opacity: 0;
    transition: $trs;
    appearance: none;
}

.CustomRange__Input::-moz-range-thumb {
    width: $thumbWidth;

    /* creating a custom design */
    height: $thumbHeight;
    background-color: $thumbColor;
    border: none;
    border-radius: $thumbBorderRadius;
    opacity: 0;
    transition: $trs;
    appearance: none;
}

/* Hover Thumb: Webkit */

.CustomRange__Input::-webkit-slider-thumb:hover {
    opacity: 1;
}

.CustomRange__Input:hover::-webkit-slider-thumb {
    opacity: 1;
}

/* Hover Thumb: Firfox */

.CustomRange__Input::-moz-range-thumb:hover {
    opacity: 1;
}

.CustomRange__Input:hover::-moz-range-thumb:hover {
    opacity: 1;
}
</style>
